import React from 'react';
import { FastField } from 'formik';

const Textarea = props => (
  <FastField name={props.name}>
    {({ field, form }) => (
      <div className="form-group">
        <label>{props.label}</label>
        <textarea
          rows={5}
          onChange={form.handleChange}
          onBlur={form.handleBlur}
          {...field}
          {...props}
          className={`input-text ${form.touched[field.name] && form.errors[field.name]
            ? 'input-text-error'
            : ''}`}
          value={form.values[field.name]}
        />
        {form.touched[field.name] && form.errors[field.name] && (
          <span className="input-text-error-msg">{form.errors[field.name] || props.error}</span>
        )}
      </div>
    )}
  </FastField>
);

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/Textarea/index.js